import { useEffect, useState } from "react";
import styles from "../buyerBusinessApprovalProcess/BuyerBusinessApprovalPage.module.scss";
import { TabComponent } from "../buyerBusinessApprovalProcess/components/tabsComponent/Tabs";
import { constants } from "../../../common/constants/constants";
import { ToastNotification } from "../../../common/components/toastNotification/ToastNotification";
import errorToast from "../../../assets/images/errorToast.svg";
import successToast from "../../../assets/images/successToast.svg";
import { useDispatch, useSelector } from "react-redux";
import { resetToastStatus } from "../../../reducerSlices/toastStatusSlice";
export const SupplierBusinessApprovalPage = () => {
  const [toastData, setToastData] = useState(constants.defaultToastData);
  const { toastStatus } = useSelector((state: any) => state);
  const dispatch = useDispatch();
  useEffect(() => {
    if (toastStatus?.message?.length > 0 && toastStatus?.type === "supplier") {
      setToastData({
        message: toastStatus?.message,
        status: toastStatus?.status,
      });
      setTimeout(() => {
        dispatch(resetToastStatus());
        setToastData(constants.defaultToastData);
      }, 2000);
    }
  }, [dispatch, toastStatus]);
  return (
    <>
      <div className={styles.approvalPage}>
        {/* <div className={styles.sideNav}>
          <AdminSideNav />
        </div> */}
        <div className={styles.right}>
          <div className={styles.heading}>Business Approval - Supplier</div>
          <TabComponent cardType="supplier" />
        </div>
      </div>
      {toastData?.message != "" ? (
        <ToastNotification
          icon={
            toastData.status === "approved" ||
            toastData.status === "rejected" ||
            toastData.status === "created" ||
            toastData.status === "edited"
              ? successToast
              : errorToast
          }
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
        />
      ) : (
        <></>
      )}
    </>
  );
};
